import { PRICE_FILTER_RANGES } from './constants'

export const applyPriceFilter = (
  products,
  { priceCode, minInput, maxInput }
) => {
  return products.filter(product => {
    const price = product.FinalPrice || 0
    const discount = product.Discount || 0
    const range = PRICE_FILTER_RANGES[priceCode]
    if (range) {
      const value = range.field === 'discount' ? discount : price
      return value >= range.min && (range.max === null || value <= range.max)
    }
    const min = minInput !== '' ? Number.parseFloat(minInput) : null
    const max = maxInput !== '' ? Number.parseFloat(maxInput) : null
    if (min === null && max === null) return true
    if (min === null) return price <= max
    if (max === null) return price >= min
    return price >= min && price <= max
  })
}
